<template>
  <div>
    <Table border :columns="columns1" :data="data1"></Table>
    <br />
    <Page
        :total="total"
        show-total
        @on-change="changePage"
        @on-page-size-change="changePagesize"
    />
  </div>
</template>
<script>
export default {
  props: {
    workId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      imgVisible: false,
      columns1: [

        {
          title: "服务态度",
          minWidth: 120,
          key: "attitude",
          align: "center",
          render: (h, params) => {
            let dom = null;
            dom = h("div", [
              // 插入评分
              h("Rate", {
                style: {
                  display: "block",
                  color: "gray",
                },
                props: {
                  count: 5,
                  disabled: true,
                  value: params.row.attitude,
                },
              }),
            ]);
            return dom;
          },
        },
        // {
        //   title: "响应速度",
        //   minWidth: 120,
        //   key: "speed",
        //   align: "center",
        //   render: (h, params) => {
        //     let dom = null;
        //     dom = h("div", [
        //       // 插入评分
        //       h("Rate", {
        //         style: {
        //           display: "block",
        //           color: "gray",
        //         },
        //         props: {
        //           count: 5,
        //           disabled: true,
        //           value: params.row.speed,
        //         },
        //       }),
        //     ]);
        //     return dom;
        //   },
        // },
        // {
        //   title: "服务质量",
        //   minWidth: 120,
        //   align: "center",
        //   key: "quality",
        //   render: (h, params) => {
        //     let dom = null;
        //     dom = h("div", [
        //       // 插入评分
        //       h("Rate", {
        //         style: {
        //           display: "block",
        //           color: "gray",
        //         },
        //         props: {
        //           count: 5,
        //           disabled: true,
        //           value: params.row.quality,
        //         },
        //       }),
        //     ]);
        //     return dom;
        //   },
        // },
        {
          title: "评价内容",
          minWidth: 90,
          key: "evaluationContent",
          align: "center",
        },
        {
          title: "评价时间",
          minWidth: 170,
          align: "center",
          key: "evaluationTime",
        },
      ],
      data1: [],
      total: this.total,
    };
  },
  created() {
  },
  mounted() {
    if (this.workId) {
      this.load(this.workId);
    }
  },
  methods: {
    showImgs(src) {
      this.imgUrl = this.info.imgUrl;
      this.imgVisibles = true;
    },
    showBigPic(item) {
      this.bigPicVisible = true;
      this.bigPicUrl = item;
    },
    load(workId, page = 1) {
      let q = {};
      // let a = {}
      // a.workId = workId
      q.workId = workId;
      // q.page = page
      q.pageSize = 10;
      q.pageNum = page;
      $utils.api
          .load("/customer/customer/evaluation/list", q)
          .then((res) => {
            if (res.code > 0) {
              let data = res.rows;
              let list = data || [];
              this.data1 = list;
              this.total = res.total;
            }
          })
          .catch(() => {
            $utils.toast.error("请求错误");
          });
    },
    changePage(p) {
      this.load(this.workId, p);
    },
    changePagesize(psize) {
    },
  },
};
</script>
